module.exports = __webpack_public_path__ + "img/round_bf.093e19a1.svg";